export const isotopeItems = [
	{
		name: "C#",
		background_url: "/assets/vendors/skills/c-sharp-logo.webp",
		category: "programing_lang",
		link: "https://docs.microsoft.com/en-us/dotnet/csharp/",
		description:
			"C# is a general-purpose, modern and object-oriented programming language pronounced as “C Sharp”.It was developed by Microsoft.",
	},
	{
		name: ".NET Framework",
		background_url: "/assets/vendors/skills/microsoft-net-framework-logo.webp",
		category: "programing_lang",
		link: "https://dotnet.microsoft.com/download/dotnet-framework",
		description:
			".NET Framework is a software framework developed by Microsoft that runs primarily on Microsoft Windows.",
	},
	{
		name: "JavaScript",
		background_url: "/assets/vendors/skills/javascript-js-logo.webp",
		category: "programing_lang web_development",
		link: "https://www.javascript.com/",
		description:
			"JavaScript is among the most powerful and flexible programming languages of the web. It powers the dynamic behavior on most websites.",
	},
	{
		name: "PHP",
		background_url: "/assets/vendors/skills/php-logo.webp",
		category: "programing_lang web_development",
		link: "https://www.php.net/",
		description:
			"PHP is a server scripting language, and a powerful tool for making dynamic and interactive Web pages.",
	},
	{
		name: "Sharepoint",
		background_url: "/assets/vendors/skills/microsoft-sharepoint-logo.webp",
		category: "programing_lang web_development",
		link: "https://www.microsoft.com/en-us/microsoft-365/sharepoint/collaboration",
		description:
			"SharePoint is a web-based collaborative platform that integrates with Microsoft Office. It is primarily sold as a document management and storage system.",
	},
	{
		name: "Node JS",
		background_url: "/assets/vendors/skills/nodejs-logo.webp",
		category: "programing_lang",
		link: "https://nodejs.org/en/",
		description:
			"Node.js is an open-source, cross-platform, back-end, JavaScript runtime environment that executes JavaScript code outside a web browser.",
	},
	{
		name: "HTML",
		background_url: "/assets/vendors/skills/html5-logo.webp",
		category: "web_development",
		link: "https://www.w3schools.com/html/",
		description:
			"Hypertext Markup Language is the standard markup language for documents designed to be displayed in a web browser.",
	},
	{
		name: "CSS",
		background_url: "/assets/vendors/skills/css-3-logo.webp",
		category: "web_development",
		link: "https://www.w3schools.com/css/",
		description:
			"Cascading Style Sheets is a style sheet language used for describing the presentation of a document written in a markup language such as HTML.",
	},
	{
		name: "jQuery",
		background_url: "/assets/vendors/skills/jquery-logo.webp",
		category: "web_development",
		link: "https://jquery.com/",
		description:
			"jQuery is a JavaScript library designed to simplify HTML DOM tree traversal and manipulation, as well as event handling, CSS animation, and Ajax.",
	},
	{
		name: "Bootstrap",
		background_url: "/assets/vendors/skills/bootstrap-logo.webp",
		category: "web_development",
		link: "https://getbootstrap.com/",
		description:
			"Bootstrap is a free and open-source CSS framework directed at responsive, mobile-first front-end web development.",
	},
	{
		name: "AngularJS",
		background_url: "/assets/vendors/skills/angular-logo.webp",
		category: "programing_lang web_development",
		link: "https://angularjs.org/",
		description:
			"AngularJS is a JavaScript-based open-source front-end web framework to address many of the challenges encountered in developing single-page applications.",
	},
	{
		name: "Microsoft SQL Server",
		background_url: "/assets/vendors/skills/microsoft-sql-server-logo.webp",
		category: "databases",
		link: "https://www.microsoft.com/en-us/sql-server",
		description:
			"Microsoft SQL Server is a relational database management system. As a database server, it is a software product for storing and retrieving data as requested by other software applications.",
	},
	{
		name: "PostgreSQL",
		background_url: "/assets/vendors/skills/postgresql-logo.webp",
		category: "databases",
		link: "https://www.postgresql.org/",
		description:
			"PostgreSQL, also known as Postgres, is a free and open-source relational database management system emphasizing extensibility and SQL compliance.",
	},
	{
		name: "NestJS",
		background_url: "/assets/vendors/skills/nestjs-logo.webp",
		category: "programing",
		link: "https://nestjs.com/",
		description:
			"A progressive Node.js framework for building efficient, reliable and scalable server-side applications.",
	},
	{
		name: "MySQL",
		background_url: "/assets/vendors/skills/MySQL-logo.webp",
		category: "databases",
		link: "https://www.mysql.com/",
		description:
			"MySQL Database Service is a fully managed database service to deploy cloud-native applications using the world's most popular open source database.",
	},
	{
		name: "Redis",
		background_url: "/assets/vendors/skills/redis-logo.webp",
		category: "databases",
		link: "https://redis.io/",
		description:
			"Redis is an in-memory data structure project implementing a distributed, in-memory key–value database with optional durability.",
	},
	{
		name: "Oracle",
		background_url: "/assets/vendors/skills/oracle-logo.webp",
		category: "databases",
		link: "https://www.oracle.com/database/",
		description:
			"Oracle Database is a multi-model database management system. It is a database commonly used for running online transaction processing, data warehousing and mixed database workloads.",
	},
	{
		name: "Azure",
		background_url: "/assets/vendors/skills/microsoft-azure-logo.webp",
		category: "cloud_reporting",
		link: "https://azure.microsoft.com/en-us/",
		description:
			"Microsoft Azure, commonly referred to as Azure, is a cloud computing service created by Microsoft for building, testing, deploying, and managing applications and services through Microsoft-managed data centers.",
	},
	{
		name: "AWS",
		background_url: "/assets/vendors/skills/amazon-web-services-aws-logo.webp",
		category: "cloud_reporting",
		link: "https://aws.amazon.com/",
		description:
			"Amazon Web Services is a subsidiary of Amazon providing on-demand cloud computing platforms and APIs to individuals, companies, and governments, on a metered pay-as-you-go basis.",
	},
	{
		name: "Heroku",
		background_url: "/assets/vendors/skills/heroku-logo.webp",
		category: "cloud_reporting",
		link: "https://www.heroku.com/",
		description:
			"Heroku is a cloud platform as a service supporting several programming languages. One of the first cloud platforms, Heroku has been in development since June 2007.",
	},
	{
		name: "SQL Server Analysis Services",
		background_url: "/assets/vendors/skills/microsoft-sql-server-logo.webp",
		category: "cloud_reporting",
		link: "https://docs.microsoft.com/en-us/analysis-services/instances/install-windows/install-analysis-services?view=asallproducts-allversions",
		description:
			"Microsoft SQL Server Analysis Services, SSAS, is an online analytical processing and data mining tool in Microsoft SQL Server. SSAS is used as a tool by organizations to analyze and make sense of information possibly spread out across multiple databases, or in disparate tables or files.",
	},
	{
		name: "Power BI",
		background_url: "/assets/vendors/skills/power-bi-microsoft-logo.webp",
		category: "cloud_reporting",
		link: "https://powerbi.microsoft.com/en-us/",
		description:
			"Power BI is a business analytics service by Microsoft. It aims to provide interactive visualizations and business intelligence capabilities with an interface simple enough for end users to create their own reports and dashboards.",
	},
	{
		name: "DevExpress",
		background_url: "/assets/vendors/skills/devexpress-logo.webp",
		category: "cloud_reporting",
		link: "https://www.devexpress.com/",
		description:
			"DevExpress provides best-in-class UI controls, tools, and frameworks for WinForms, ASP.NET, MVC, Blazor, ASP.NET Core, WPF, VCL, Xamarin, and JavaScript.",
	},
	{
		name: "Git",
		background_url: "/assets/vendors/skills/git-logo.webp",
		category: "other",
		link: "https://git-scm.com/",
		description:
			"Git is a distributed version-control system for tracking changes in source code during software development.",
	},
	{
		name: "JSON",
		background_url: "/assets/vendors/skills/json-logo.webp",
		category: "other",
		link: "https://www.json.org/json-en.html",
		description:
			"JSON (JavaScript Object Notation) is a lightweight data-interchange format. It is easy for humans to read and write. It is easy for machines to parse and generate.",
	},
	{
		name: "XML",
		background_url: "/assets/vendors/skills/xml-logo.webp",
		category: "other",
		link: "https://developer.mozilla.org/en-US/docs/Web/XML/XML_introduction",
		description:
			"Extensible Markup Language is a markup language that defines a set of rules for encoding documents in a format that is both human-readable and machine-readable.",
	},
	{
		name: "Agile",
		background_url: "/assets/vendors/skills/agile-frameworks-logo.webp",
		category: "other",
		link: "https://www.agilealliance.org/agile101/",
		description:
			"Agile is an iterative approach to project management and software development that helps teams deliver value to their customers faster and with fewer headaches.",
	},
	{
		name: "Solidity",
		background_url: "/assets/vendors/skills/solidity-logo.webp",
		category: "programing_lang",
		link: "https://docs.soliditylang.org/en/v0.8.10/",
		description:
			"Solidity is an object-oriented, high-level language for implementing smart contracts. Smart contracts are programs which govern the behaviour of accounts within the Ethereum state.",
	},
	{
		name: "Salesforce",
		background_url: "/assets/vendors/skills/salesforce-logo.webp",
		category: "other",
		link: "https://www.salesforce.com/",
		description:
			"Salesforce provides customer relationship management service and also provides enterprise applications focused on customer service, marketing automation, analytics and application development.",
	},
	{
		name: "RabbitMQ",
		background_url: "/assets/vendors/skills/rabbitmq-logo.png",
		category: "other",
		link: "https://www.rabbitmq.com/",
		description:
			"RabbitMQ is a message broker - an intermediary for messages between applications. It gives your applications a common platform and the flexibility to route and deliver messages to various destinations, such as data stores, microservices, hosted services, and more.",
	},
	{
		name: "Docker",
		background_url: "/assets/vendors/skills/docker-logo.png",
		category: "other",
		link: "https://www.docker.com/",
		description:
			"Docker is a software platform that allows you to build, test, and deploy applications quickly. Docker packages software into standardized units called containers that have everything the software needs to run including libraries, system tools, code, and runtime.",
	},
	{
		name: "Kubernetes",
		background_url: "/assets/vendors/skills/kubernetes-logo.png",
		category: "other",
		link: "https://kubernetes.io/",
		description:
			"Kubernetes is an open-source system for automating deployment, scaling, and management of containerized applications.",
	},
];

export const testimonyItems = [
	{
		id: 0,
		company_url: "https://privatbank.ua/",
		company_name: "PrivatBank",
		past_company_name: "Stefanini EMEA",
		worked_with: "Dragos",
		name: "Razvan Tapu",
		job: "Chief Technology Officer",
		paragraph: `When we met, we were at the beginning of our careers inside the company, each one trying to adapt to his new role. Being in the position of Applications Delivery Manager, Dragos was part of my team, counting at the time more than 50 persons. Initially we worked together within the company, then after a few months, he went to work on a project at the client's headquarters on a long-term basis. Nevertheless, we kept in touch through recurring meetings and followed-up his progress as well as how he managed the project, maintained a good customer relationship and delivered according to the quality standards. He showed great spirit, willing to adapt to new challenges and to new teams, which helped our business a lot. During our collaboration, I have witnessed how Dragos has evolved and strongly developed both his technical and business skills, which made our discussions more and more interesting.`,
		avatar: "/assets/linkedin/razvan_tapu.jpg",
	},
	{
		id: 1,
		company_url: "https://www.honeywell.com",
		company_name: "Honeywell",
		past_company_name: "Garrett Motion",
		worked_with: "Paul",
		name: "Cristina Deju",
		job: "Business Ops Leader",
		paragraph:
			"In his IT role, Paul has proven more than just expertize area, through his customer focus and willingness to support. He is a solid professional who is a reliable working partner to the Commercial Excellence team.",
		avatar: "/assets/linkedin/cristina_deju.jpg",
	},
	{
		id: 2,
		company_url: "https://stefanini.com/",
		company_name: "Stefanini EMEA",
		past_company_name: "",
		worked_with: "Dragos",
		name: "Florin Stefan",
		job: "Applications Development Director",
		paragraph: `I worked with Dragos Leonte at Stefanini in the Applications Development department, initially being his Line Manager, and later in the role of Applications Development Director. At the time, Dragos was an ambitious young programmer, willing to learn and develop within the department, as well as within the company. The interaction between us was always open and positive, and it was closely related to the overall picture of the projects under maintenance and/or development, the relationship with the clients on the projects he participated in as well as his contractual relationship with the company. During the years we collaborated, he was committed, responsible and delivered according to expectations.`,
		avatar: "/assets/linkedin/florin_stefan.jpg",
	},
	{
		id: 3,
		company_url: "https://www.aptiv.com/",
		company_name: "Aptiv",
		past_company_name: "Garrett Motion",
		worked_with: "Paul",
		name: "Cosmin Vara",
		job: "Global BPO Leader",
		paragraph:
			"I was working with Paul for a few years in different projects in the beginning and after, as part of my team. He is special guy, smart IT developer and hard worker and in the same time a sensitive person. It’s unique mix that can put heart in what he is doing. If he wants he can be a brilliant programmer or a successful business man. I really recommend him for his technical skills and business process understanding.",
		avatar: "/assets/linkedin/cosmin_vara.jpg",
	},
	{
		id: 4,
		company_url: "https://www.wehkamp.nl/",
		company_name: "Wehkamp",
		past_company_name: "NextUp",
		worked_with: "Paul",
		name: "Sergiu Ilies",
		job: "Senior Software Engineer",
		paragraph:
			"I had the chance to work with Paul at NextUp on their accounting software. This meant working on complex logic which demanded strong .NET and SQL skills which Paul poses. He is a hard-working, energetic and highly motivated person. I believe he would be a great asset to any organization.",
		avatar: "/assets/linkedin/sergiu_ilies.jpg",
	},
	{
		id: 5,
		company_url: "https://www.linkedin.com/company/confidentiallosangeles/",
		company_name: "Confidential",
		past_company_name: "NextUp",
		worked_with: "Paul",
		name: "Ionut Nicolescu",
		job: "Senior Microsoft Cloud Engineer",
		paragraph: `It was great pleasure to work with Paul, he is a good professional , energetic and passionate about his programming work.
      Immediately after I met him, I felt the connection and the trust which developed between us. 
      After two years , I can say that Paul is always willing to give hands to help others, and always open minded for new ideas. 
      I would highly recommend Paul for a good company in the IT industry,because he has the coding skills.`,
		avatar: "/assets/linkedin/ionut_nicolescu.jpg",
	},
	{
		id: 6,
		company_url: "https://www.uipath.com/",
		company_name: "UiPath",
		past_company_name: "NextUp",
		worked_with: "Paul",
		name: "Ion Miron",
		job: "Principal Engineering Manager",
		paragraph: `I've worked with Paul for about 9 months during which I was impressed by his self motivation and constructive positive attitude. 
    His programming skills made him rapidly become a truly valuable asset of the team. Dedication towards performance and making things better allows him to improve everyday. 
    His analytical skills help him deliver great and reliable code. By always trying to fully understand the business purpose of what he's working on he is not only able to implement the business but also increase the value of the business by discussing it and raising questions to the business analyst. 
    I saw in him a person that is always trying to improve by reading very good programming books, by searching the net for latest technology and by listening to what the other team members can help him increase with. 
    He has all the right skill set to integrate and help any team and project. 
    Without a doubt, I confidently recommend Paul.`,
		avatar: "/assets/linkedin/ion_miron.jpg",
	},
	{
		id: 7,
		company_url: "https://www.playtika.com/",
		company_name: "Playtika",
		past_company_name: "SETRIO",
		worked_with: "Paul",
		name: "Ionut Frunza",
		job: "Senior Software Developer",
		paragraph: `Paul is the most hard-working person I've ever met. Within the year we have worked together, he had improved his programming skills at a very fast pace. 
    Paul is also a very dependable person, responds quickly to every task he's given and he's really nice to get along with.`,
		avatar: "/assets/linkedin/ionut_frunza.jpg",
	},
	{
		id: 8,
		company_url: "https://www.allianztiriac.ro/",
		company_name: "Allianz-Tiriac Asigurari",
		past_company_name: "SETRIO",
		worked_with: "Paul",
		name: "Corina Mutu",
		job: "IT Strategy & Project Manager",
		paragraph: `I've met Paul in september 2013 and we have been working in the same team since. 
    In the time that we have been coworkers, Paul has always proved that he is a very capable person, always wanting to work more, rapidly develop his skills and knowledges and have better results. He is consistently pleasant, and takes on all assignments with enthusiasm and dedication. 
    Paul is also able to work effectively with other co-workers, making him a great addition to the team. 
    For all of these reasons, I think Paul will make a fine addition to any team he will be a part of.`,
		avatar: "/assets/linkedin/corina_mutu.jpg",
	},
	{
		id: 9,
		company_url: "https://www.microsoft.com/",
		company_name: "Microsoft",
		past_company_name: "Dell Technologies",
		worked_with: "Dragos",
		name: "Gabriel Oprea",
		job: "Senior Software Engineer",
		paragraph: `I had the pleasure of working with Dragos at Dell, we were both part of the first local team recruited for the "Lease Transformation" program. The team was composed of 1 Scrum Master, 1 Project Manager and 7 Developers. As Dell Financial Service acquired a new leasing platform our task was to build a suite of applications that will provide the integration between Dell already existing applications and the new leasing platform. In this context, we had the opportunity to share ideas and to debate on the best approach for each application as we were building our microservice architecture. I had a great collaboration with Dragos and enjoyed our brain storming session about what will be the best scalable approach for our design. He was open minded to suggestions and was passionate to learn new technologies and new processes.`,
		avatar: "/assets/linkedin/gabriel_oprea.jpg",
	},
];

export const chartData = [
	{ year: "2017", revenue: 0, expenses: 260, netProfit: -260 },
	{ year: "2018", revenue: 5458, expenses: 911, netProfit: 4383 }, // Calculated from values/rate roughly
	{ year: "2019", revenue: 69230, expenses: 14294, netProfit: 54308 },
	{ year: "2020", revenue: 110705, expenses: 20048, netProfit: 89835 },
	{ year: "2021", revenue: 125059, expenses: 22105, netProfit: 101978 },
	{ year: "2022", revenue: 133416, expenses: 27395, netProfit: 106021 },
	{ year: "2023", revenue: 195426, expenses: 34423, netProfit: 161004 },
	{ year: "2024", revenue: 198190, expenses: 40910, netProfit: 157280 },
];
// Note: chartData above is approximated from the backend logic which divides by exchange rate.
// Backend Logic:
// revenueData = [0, 25397, 328512, 535489, 615340, 657943, 966677, 985915]
// ronEuroExRate = [4.5681, 4.6535, 4.7452, 4.8371, 4.9204, 4.9315, 4.9465, 4.9746]
// I should probably calculate it exactly as the backend did if I want exact match.
